import React, { useState, useEffect } from 'react';
import Sidebar from './components/Sidebar';
import Chapter from './components/Chapter';
import AIAgent from './components/AIAgent';
import Terminal from './components/Terminal';
import { chapters } from './data/chapters';

export default function App() {
  const [activeId, setActiveId] = useState(chapters[0].id);
  const [progress, setProgress] = useState(0);
  const [terminalOpen, setTerminalOpen] = useState(false);

  const activeIndex = chapters.findIndex((c) => c.id === activeId);
  const chapter = chapters[activeIndex];

  useEffect(() => {
    const onScroll = () => {
      const scrolled = window.scrollY;
      const height = document.documentElement.scrollHeight - window.innerHeight;
      setProgress(height > 0 ? (scrolled / height) * 100 : 0);
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const goTo = (id: string) => {
    setActiveId(id);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const goPrev = () => {
    if (activeIndex > 0) goTo(chapters[activeIndex - 1].id);
  };

  const goNext = () => {
    if (activeIndex < chapters.length - 1) goTo(chapters[activeIndex + 1].id);
  };

  return (
    <div className="app">
      <div className="reading-progress" style={{ width: `${progress}%` }} />
      
      <Sidebar activeId={activeId} onSelect={goTo} />
      
       <main className="main">
         {/* Interactive terminal at the start */}
         {activeId === 'prologue' && (
           <article className="chapter">
             <Chapter
               chapter={chapter}
               onPrev={goPrev}
               onNext={goNext}
               isFirst={activeIndex === 0}
               isLast={activeIndex === chapters.length - 1}
             />
             <Terminal commands={[]} interactive title="kernel shell" hideSectionTitle />
           </article>
         )}
        
        {activeId !== 'prologue' && (
          <Chapter
            chapter={chapter}
            onPrev={goPrev}
            onNext={goNext}
            isFirst={activeIndex === 0}
            isLast={activeIndex === chapters.length - 1}
          />
        )}
      </main>

      <AIAgent chapterId={activeId} />

      <button className="terminal-toggle-fixed" onClick={() => setTerminalOpen(!terminalOpen)}>
        &gt;_
      </button>

      {terminalOpen && (
        <div className="terminal-modal-overlay" onClick={() => setTerminalOpen(false)}>
          <div className="terminal-modal" onClick={(e) => e.stopPropagation()}>
            <div className="terminal-titlebar">
              <div className="terminal-dot red" />
              <div className="terminal-dot yellow" />
              <div className="terminal-dot green" />
              <span className="terminal-titlebar-text">kernel shell</span>
              <button className="terminal-close" onClick={() => setTerminalOpen(false)}>
                ✕
              </button>
            </div>
            <div className="terminal-modal-body">
              <Terminal interactive title="kernel shell" hideSectionTitle hideTerminalTitleBar />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
